import { z } from "zod";

export const otpSchema = z.object({
  otp: z
    .string()
    .min(6, { message: "OTP must be 6 digits" })
    .max(6, { message: "OTP must be 6 digits" }),
});

export type OtpModel = z.infer<typeof otpSchema>;
